module.exports = __webpack_public_path__ + "img/fullscreen-exit.d3ac6ebb.svg";